import UniversalCookies, { type CookieGetOptions, type CookieSetOptions } from 'universal-cookie';

const cookies = new UniversalCookies();

export const isLocalStorageAvailable: boolean = (() => {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      localStorage.removeItem('setItem');
      localStorage.setItem('test', 'test');
      localStorage.removeItem('test');
      return true;
    } catch {
      return false;
    }
  } else {
    return false;
  }
})();

export const checkCookieEnabled = (): boolean => cookies.get('cookieConsent_status') !== 'dismiss';

export const getCookie = (name: string, options?: CookieGetOptions): string | undefined => cookies.get(name, options);

export const setCookie = (name: string, value: string, options?: CookieSetOptions): void => {
  cookies.set(name, value, options);
};

export const removeCookie = (name: string, options?: CookieSetOptions): void => {
  cookies.remove(name, options);
};

export const getStoredValue = <T>(name: string): T | null => {
  if (isLocalStorageAvailable) {
    try {
      const item = localStorage.getItem(name);
      return item ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  }
  return null;
};

export const setStoredValue = <T>(name: string, value: T): void => {
  if (isLocalStorageAvailable) {
    localStorage.removeItem('setItem');
    localStorage.setItem(name, JSON.stringify(value));
  }
};

export const removeStoredValue = (name: string): void => {
  if (isLocalStorageAvailable) {
    localStorage.removeItem(name);
  }
};
